<div class="space-y-4 p-4">
    <!-- Availability Toggle Section -->
    <div class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-center justify-between">
            <div>
                <h3 class="text-lg font-semibold text-gray-800">Today's Availability</h3>
                <p class="text-sm text-gray-600">
                    {{ isAvailable ? 'You are available to accept batches' : 'You are not available for batches' }}
                </p>
            </div>
            <button (click)="toggleAvailability()" [disabled]="isUpdatingAvailability"
                class="availability-toggle relative flex items-center justify-center w-16 h-8 rounded-full transition-colors duration-200"
                [class]="isAvailable ? 'bg-green-500' : 'bg-gray-300'">

                <div class="absolute w-6 h-6 bg-white rounded-full transition-transform duration-200"
                    [class]="isAvailable ? 'translate-x-4' : 'translate-x-0'"></div>

                <div *ngIf="isUpdatingAvailability" class="absolute inset-0 flex items-center justify-center">
                    <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
            </button>
        </div>

        <div class="availability-status mt-4 p-3 rounded-lg"
            [class]="isAvailable ? 'bg-green-50 text-green-800' : 'bg-gray-50 text-gray-600'">
            <div class="flex items-center space-x-2">
                <i class="pi"
                    [class]="isAvailable ? 'pi-check-circle text-green-600' : 'pi-info-circle text-gray-500'"></i>
                <span class="text-sm">
                    {{ isAvailable ? 'You will receive batch notifications' : 'You will not receive new batch
                    notifications' }}
                </span>
            </div>
        </div>
    </div>

    <div class="bg-white rounded-lg p-6 shadow-sm">
        <h2 class="text-xl font-bold text-gray-800 mb-4">
            Today's Summary
        </h2>
        <div class="grid grid-cols-2 gap-4">
            <div class="bg-green-50 p-4 rounded-lg">
                <div class="text-2xl font-bold text-green-600">{{ activeBatchesCount }}</div>
                <div class="text-sm text-gray-600">Accepted Batches</div>
            </div>
            <div class="bg-blue-50 p-4 rounded-lg">
                <div class="text-2xl font-bold text-blue-600">${{ expectedEarnings.toFixed(2) }}</div>
                <div class="text-sm text-gray-600">Expected Earnings</div>
            </div>
        </div>
    </div>

    <div class="bg-white rounded-lg p-6 shadow-sm">
        <h3 class="text-lg font-semibold text-gray-800 mb-3">Quick Actions</h3>
        <div class="space-y-3">
            <button class="w-full bg-green-500 text-white py-3 px-4 rounded-lg font-medium" (click)="startShopping()">
                Start Shopping
            </button>
            <button class="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-medium"
                (click)="viewAvailableBatches()">
                View Available Batches
            </button>
        </div>
    </div>
</div>
<p-confirmdialog />